/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:21:55
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

export const TOGGLE_FORM_SENDING_STATUS = 'TOGGLE_FORM_SENDING_STATUS';



// WEBPACK FOOTER //
// ./src/store/modules/Complains/mutation-types.js